/* eslint-disable indent */
import {
  configureStore,
  isRejectedWithValue,
  type Middleware,
  type ThunkAction,
  type Action,
  isRejected,
} from '@reduxjs/toolkit';

import { rootReducer } from './rootReducer';

import { api } from '@/app/api/baseApi';
import { changeIsErrorCanal } from '@/features/mapbox/mapSlice';

export const unauthenticatedMiddleware: Middleware =
  ({ dispatch }) =>
  (next) =>
  (action) => {
    if (
      Boolean(isRejectedWithValue(action)) &&
      action.payload.errorCode === 401
    ) {
      // データ連携基盤のレスポンスでステータスコードが401の場合
      dispatch(changeIsErrorCanal(true));
    } else if (
      Boolean(isRejectedWithValue(action)) &&
      action.payload.errorCode === 500
    ) {
      // データ連携基盤のレスポンスでステータスコードが500の場合
      dispatch(changeIsErrorCanal(true));
    } else if (
      Boolean(isRejectedWithValue(action)) &&
      action.payload.name === 'Error'
    ) {
      // データ連携基盤のレスポンス内容がエラーの場合
      dispatch(changeIsErrorCanal(true));
    } else if (
      Boolean(isRejected(action)) &&
      action.error.name === 'TypeError' &&
      action.error.message === 'Network request failed'
    ) {
      // データ連携基盤にアクセスしたがCORSエラーの場合
      dispatch(changeIsErrorCanal(true));
    }

    return next(action);
  };

export const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat([api.middleware, unauthenticatedMiddleware]),
});

export type RootState = ReturnType<typeof store.getState>;

export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
